import type { FaireProductEntity } from "../../entity_types/product";

export const p_vs3rgbc6gg: FaireProductEntity = {
  token: "p_vs3rgbc6gg",
  type: "product",
  name: "Sicilian Pesto 190g glass",
  brandToken: "b_anzaxnuac4",
  brandName: "AIDA di Giangreco",
  imageUrl:
    "https://cdn.faire.com/fastly/75eaa0c2da7ee4716fbbf912bd5ee8651055b3f189ba469ebfb8a6c07040b887.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f19cbb409328d2531c0d81b872763a170ddf3b1f07319156ff895ce1f991c2de.jpeg",
    "https://cdn.faire.com/fastly/4391771f1aba3998ebc55e9a726a1e6471e1535a1a094e3456a935b48a5233c5.jpeg",
  ],
  priceDollars: 5,
  description:
    "For the production of typical Sicilian Pestos AIDA BIO uses only carefully selected ingredients and raw materials from regional artisans and never adds any preservatives, dyes, flour or thickeners, seasoning only with aromatic herbs and extra virgin olive oil to make the genuineness better known of what you eat. In this way he manages to elaborate ancient typical Sicilian and Mediterranean recipes by transferring all this goodness into comfortable jars.\n\nSicilian pesto is a traditional recipe typical of the cuisine of our land. A fresh condiment that contains all the taste and scent of the Mediterranean. Inspired by grandma's classic recipe, it is the perfect combination between the strong character of sun-dried tomatoes and the sweetness of almonds, in a simply irresistible balance of flavours! Prepared by hand and with natural ingredients, it is the right compromise between the desire for healthier nutrition with taste",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:12.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
